const favourite_animal  = `One of my favorite animals is the reindeer. 
They live in cold places like Finland and have special features that help them survive in the snow.
Reindeer have thick fur that keeps them warm in the winter. 
They also have wide hooves that help them walk on the snow without sinking. 
This makes it easier for them to find food, like plants and moss, even when it's snowy outside.
Reindeer are known for their big antlers, which they use to defend themselves and find food. 
These antlers can also be different for males and females. 
They are strong and can help reindeer dig through the snow to find food in the winter.
In some places, people use reindeer to pull sleds and carry heavy things. 
Reindeer are important to some cultures and have been a part of their lives for a long time.
Overall, reindeer are amazing animals that can survive in cold places like Finland. 
They are strong and have special features that help them live in the snow. 
They are also important to some cultures and have a special place in their hearts.`;

export default favourite_animal;